import projection from '../generated/pwg204f1.json';
import { AcceptanceManifest } from '../types';

export const pwg204f1AcceptanceManifest = projection as AcceptanceManifest;
